if (!customElements.get('product-addon')) {

  var ProductAddon = class extends HTMLElement {

    connectedCallback() {

      this.checkbox.addEventListener("click", this.onCheckboxClick.bind(this));

      if (this.detailsLink) {
        this.detailsLink.addEventListener("click", this.onDetailsLinkClick.bind(this));
      }

      if (this.formAddPropertiesButton) {
        this.formAddPropertiesButton.addEventListener("click", this.onAddPropertiesClick.bind(this));
      }

      if (this.drawer) {
        const drawerForms = this.drawer.querySelectorAll("form");
        drawerForms.forEach(form => {
          form.addEventListener("submit", this.onFormSubmit.bind(this));
        });
      }


    }

    // Elements

    get addonContainer() {
      // Addon Widget containing all addons.
      return this.closest(".product-addons-widget");
    }
    // get addonDetails() {
      // Element containing the addon line item properties (if the addon has them).
      // return this.addonContainer.querySelector(`product-addon-details[data-addon-id="${this.addonId}"]`);
    // }
    get checkbox() {
      // The "checkbox" button element that the customer clicks to add the addon product to the parent product.
      return this.querySelector('[data-addon-checkbox-button]');
    }
    get detailsLink() {
      // The "link" button element that the customer clicks if they want to edit the addon product's line item properties (re-opens the drawer).
      return this.querySelector('[data-addon-details-button]');
    }
    get drawer() {
      // The drawer / openable element containing the form.
      return document.getElementById(this.drawerId);
    }
    get form() {
      // The form element where the customer enters details which get added to the addon product's line item properties.
      if (this.drawer) {
        const form = this.drawer.querySelector("tabset-content:not([hidden]) form");
        return form;
      }
    }
    get formAddPropertiesButton() {
      if (this.drawer) {
        return this.drawer.querySelector("[data-add-properties-button]");
      }
    }

    // Theme Elements (REPLACE THESE with the theme's element selectors.)

    get productForm() {
      return this.closest('.product-info').querySelector('.js-product-form');
    }

    // Attributes

    get drawerId() {
      return this.dataset.addonOpenableId;
    }
    get addonId() {
      return this.dataset.addonId;
    }
    get variantId() {
      return Number(this.dataset.variantId);
    }
    get added() {
      return this.hasAttribute("added");
    }
    set added(value) {
      if (value === true) {
        this.setAttribute("added", "");
      }
      else {
        this.removeAttribute("added");
      }
    }
    get hasProperties() {
      return (this.dataset.addonProperties === undefined) ? false : true;
    }

    // Functions

    removeAddon() {

      // If the addon has properties, remove them.
      if (this.hasProperties) {
        this.dataset.addonProperties = "";
        this.form.reset();
      }

      this.added = false;

      // Check the checkbox.
      this.classList.remove("product-addon--added");

    }
    addAddon() {

      // If the addon has properties, add them.
      if (this.hasProperties) {

        const inputs = this.form.querySelectorAll("input, select");
        const addonDetails = { properties: {} };

        addonDetails.properties = [];

        inputs.forEach(input => {
          const property = {};
          property[input.name] = input.value
          addonDetails.properties.push(property);
        });

        this.dataset.addonProperties = JSON.stringify(addonDetails);

      }

      this.added = true;

      // Check the checkbox.
      this.classList.add("product-addon--added");


    }

    // Event Handlers

    onCheckboxClick(e) {

      if (this.added) {
        this.removeAddon();
      }
      else {
        if (this.hasProperties) {
          this.drawer.open();
        }
        else {
          this.addAddon();
        }
      }

    }
    onDetailsLinkClick(e) {
      this.drawer.open();
    }
    onAddPropertiesClick(e) {
      this.form.requestSubmit();
    }
    onFormSubmit(e) {
      e.preventDefault();
      this.addAddon();
      this.drawer.close();
    }

  };
  window.customElements.define("product-addon", ProductAddon);

}

if (!customElements.get('addon-details-drawer')) {

  class AddonDetailsDrawer extends SideDrawer {

    constructor() {

      super();

      // ENTERPRISE - Move the drawer into the overlay group to appear above other elements when open.
      document.addEventListener("DOMContentLoaded", (event) => {
        document.querySelector(`.overlay-addon-drawers`).appendChild(this);
      });

    }

  }

  customElements.define('addon-details-drawer', AddonDetailsDrawer);

}

if (!customElements.get('tabset-tabs')) {

  class TabsetTabs extends HTMLElement {

    connectedCallback() {

    }

    deselectAll() {
      this.tabs.forEach(tab => {
        tab.deselect();
      })
    }

    get tabs() {
      return this.querySelectorAll(`tabset-tab`);
    }

  }

  customElements.define('tabset-tabs', TabsetTabs);

}

if (!customElements.get('tabset-tab')) {

  class TabsetTab extends HTMLElement {

    connectedCallback() {
      this.addEventListener("click", this.onClick.bind(this));
    }

    // Event Handlers

    onClick(event) {

      const button = event.target;
      const active = button.classList.contains("active");

      if (active) {
        return;
      }

      this.tabs.deselectAll();

      this.select();

    }

    // Functions

    select() {
      this.classList.add("active");
      this.content.show();
    }

    deselect() {
      this.classList.remove("active");
      this.content.hide();
    }

    // Elements

    get content() {
      const content = document.querySelector(`tabset-content[data-tab-id='${this.tabId}']`);
      return content;
    }

    get tabs() {
      return this.closest("tabset-tabs");
    }

    // Properties

    get tabId() {
      return this.dataset.tabId;
    }

  }

  customElements.define('tabset-tab', TabsetTab);

}

if (!customElements.get('tabset-content')) {

  class TabsetContent extends HTMLElement {

    // Functions

    show() {
      this.removeAttribute("hidden");
    }

    hide() {
      this.setAttribute("hidden", "");
    }

    // Elements

    get tab() {
      return document.querySelector(`tabset-tab[data-tab-id='${this.tabId}']`);
    }

    // Properties

    get tabId() {
      return this.dataset.tabId;
    }

  }

  customElements.define('tabset-content', TabsetContent);

}

if (!customElements.get('embroidery-live-preview')) {

  class EmbroideryLivePreview extends HTMLElement {

    connectedCallback() {

      /* ----- Begin Once-off Initialization Code ----- */

      /* 
        This code ensures that the connectedCallback is only run once, when the element
        is first added to the DOM. We do this because on this theme (Enterprise), we
        need to move the drawer outside its container to allow the drawers to work.
      */

      if (this.hasAttribute("activated")) {
        return;
      }

      this.setAttribute("activated", "");

      /* ----- End Once-off Initialization Code ----- */

      this.inputText?.addEventListener("input", this.updateText.bind(this));
      this.inputFont?.addEventListener("change", this.updateFont.bind(this));
      this.inputColor?.addEventListener("change", this.updateColor.bind(this));

      this.reset();

    }

    // Functions

    update() {
      
    }

    set(value) {
      this.innerHTML = this.textPreview(value);
    }

    clear() {
      this.innerHTML = this.textDefault;
    }

    reset() {

      // Reset Inputs
      this.inputText.value = "";      
      this.inputFont.value = "";      
      this.inputColor.value = "";      

      // Reset Properties
      this.embroideryText = "";
      this.embroideryColor = "";
      this.embroideryFont = "";
      this.embroideryPlacement = "";

      // Reset Text Preview
      this.clear();

    }

    textPreview(value) {

      /*
        value: string
        type: Text | MonogramCircle | MonogramBlock
      */

      let content;
      let format = this.format.toLowerCase();

      if (format === "text") {
        content = `<span class="embroidery-text embroidery-text--text">${ value }</span>`;
      }
      else {
        
        const letter1 = value[0] || "";
        const letter2 = value[1] || "";
        const letter3 = value[2] || "";

        const letter1String = letter1 === "" ? "" : `<span class="embroidery-text__1">${ letter1 }</span>`;
        const letter2String = letter2 === "" ? "" : `<span class="embroidery-text__2">${ letter2 }</span>`;
        const letter3String = letter3 === "" ? "" : `<span class="embroidery-text__3">${ letter3 }</span>`;

        content = `
        <span class="embroidery-text embroidery-text--monogram">
          ${ letter1String }
          ${ letter2String }
          ${ letter3String }
        </span>
        `;
      }

      return `
        <div class="embroidery-live-preview__preview format-${ format }">
          ${ content }
        </div>
      `;

    }

    // Event Handlers

    updateText(event) {

      const input = event.target;
      const value = input.value;

      if (!value) {
        this.clear();
        return;
      }

      this.set(value);

    }

    updateFont(event) {

      const select = event.target;
      const selectedOption = select.options[select.selectedIndex];

      const value = selectedOption.value;
      const format = selectedOption.dataset.monogramFormat;

      /* ----- Set Font Data ----- */

      // Clear all font classes.
      for (const className of this.classList) {
        if (className.indexOf("embroidery-font") != -1) {
          this.classList.remove(className);
        }
      }

      const fontClass = this.formatFontClassName(value);

      this.classList.add(fontClass);

      /* ----- Set Format ----- */

      // Set Format (used to format the string sent in order data)
      this.format = !format ? "Text" : format;

      if (format) {
        this.updateFontTooltip();
      }

    }

    updateFontTooltip() {

      const label = this.drawer.querySelector(`[data-hint-monogram-style]`);

      if (this.format == "ABC") {
        label.innerHTML = window.productaddons.strings.format.tooltip_abc_html;
      }
      else
      if (this.format == "ACB") {
        label.innerHTML = window.productaddons.strings.format.tooltip_acb_html;
      }
      else {
        label.innerHTML = "";
      }
      
    }

    formatFontClassName(fontname) {

      if (typeof fontname !== "string") {
        return;
      }

      let formatted = fontname;

      formatted = formatted.replace(" ", "-");
      formatted = formatted.toLowerCase();
      formatted = "embroidery-font-" + formatted;

      return formatted;

    }

    updateColor(event) {

      const select = event.target;
      const selectedOption = select.options[select.selectedIndex];

      const value = selectedOption.value;
      const color = selectedOption.dataset.swatch;

      this.style.color = color;

      if (value == "White") {
        this.style.backgroundColor = "#cccccc";
      }
      else {
        this.style.backgroundColor = "";
      }

    }


    // Elements

    get inputText() {
      return document.querySelector(this.dataset.inputText);
    }

    get inputFont() {
      return document.querySelector(this.dataset.inputFont);
    }

    get inputColor() {
      return document.querySelector(this.dataset.inputColor);
    }

    get previewText() {
      return this.querySelector(".embroidery-text");
    }

    get drawer() {
      return this.closest("addon-details-drawer");
    }

    // Properties


    get format() {
      return this.dataset.format;
    }
    set format(value) {
      this.dataset.format = value;
    }

    get text() {
      return this.dataset.embroideryText;
    }
    set text(value) {
      if (typeof value == 'string') {
        this.dataset.embroideryText = value;
      }
      else {
        delete this.dataset.embroideryText;
      }
    }

    get font() {
      return this.dataset.embroideryFont;
    }
    set font(value) {
      if (typeof value == 'string') {
        this.dataset.embroideryFont = value;
      }
      else {
        delete this.dataset.embroideryFont;
      }
    }

    get color() {
      return this.dataset.embroideryColor;
    }
    set color(value) {
      if (typeof value == 'string') {
        this.dataset.embroideryColor = value;
      }
      else {
        delete this.dataset.embroideryColor;
      }
    }

    get placement() {
      return this.dataset.embroideryPlacement;
    }
    set placement(value) {
      if (typeof value == 'string') {
        this.dataset.embroideryPlacement = value;
      }
      else {
        delete this.dataset.embroideryPlacement;
      }
    }


    get textDefault() {

      const string = `
        <div class="embroidery-live-preview__default-message text-sm">
          ${ window.productaddons.strings.live_preview.default }
        </div>
      `;

      return string;

    }

  }

  customElements.define('embroidery-live-preview', EmbroideryLivePreview);

}

console.log('product-addons.js');